import gql from 'graphql-tag';

export const GET_CUSTOMER_DETAILS = gql`
  query getCustomer($date: DateTime!, $id: Int!) {
    customer(id: $id) {
      lastAppointmentAt(date: $date)
      totalDue
    }
  }
`;
